<template>
  <div>
    <v-tabs v-model="activeTab" show-arrows>
      <v-tab  v-for="tab in tabs"  v-if="isOperateur && tab.showForOperateur || isSuperviseur" :key="tab.name" :to="tab.route">
        <v-icon left>
          {{ tab.icon }}
        </v-icon>
        {{ tab.name }}</v-tab
      >
    </v-tabs>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {},
  data() {
    return {
      activeTab: "",
      tabs: [
        {
          name: "Dashboard",
          route: "/superviseur/",
          icon: "mdi-monitor-dashboard",
          showForOperateur:true

        },
        {
          name: "Animateurs",
          route: "/superviseur/animateurs",
          icon: "mdi-account-multiple-check",
          showForOperateur:true
        },
        {
          name: "Groupes",
          route: "/superviseur/groupes",
          icon: "mdi-home-group",
          showForOperateur:false
        },
        /*     {
          name: "Groupes Scroll",
          route: "/superviseur/groupesScroll",
          icon: "mdi-home-group",
        },  */
        /* {
          name: "Membres",
          route: "/superviseur/membres",
          icon: "mdi-account-group",
        }, */
        {
          name: "Formations de masse",
          route: "/superviseur/fomationsDeMasse",
          icon: "mdi-school",
          showForOperateur:false
        },
        {
          name: "Formations de groupe",
          route: "/superviseur/fomationsDeGroupe",
          icon: "mdi-school-outline",
          showForOperateur:false
        },
        {
          name: "Dotations",
          route: "/superviseur/dotations",
          icon: "mdi-tractor-variant",
          showForOperateur:false
        },
        {
          name: "Campagnes",
          route: "/superviseur/rapports",
          icon: "mdi-format-list-bulleted-triangle",
          showForOperateur:true
        }, 
        {
          name: "Données Totaux",
          route: "/superviseur/campagnes",
          icon: "mdi-format-list-text",
          showForOperateur:true
        },
        {
          name: "Données Détails",
          route: "/superviseur/campagnesDetails",
          icon: "mdi-format-list-checks",
          showForOperateur:true
        },
      ],
    };
  },
  methods: {
    ...mapActions({}),
 
  },
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
      regionSupervisees: (state) => state.Utils.listeRegionsSupervisees,
      isAnimateur: (state) => state.Auth.isAnimateur,
      isSuperAdmin: (state) => state.Auth.isSuperAdmin,
      isAdmin: (state) => state.Auth.isAdmin,
      isSuperviseur: (state) => state.Auth.isSuperviseur,
      isOperateur: (state) => state.Auth.isOperateur,
      isGroupe: (state) => state.Auth.isGroupe,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
